import axios from "axios";
import RedisInfo from "./RedisInfo";
import Swal from "sweetalert2";
import DealerShipDetails from "./DealerShipInfo";
import { Outlet } from "react-router-dom";
import { de } from "date-fns/locale";

const apiUrl = process.env.REACT_APP_API_URL;


// enable/disable auto debit
const updateAutoDebit = async (serviceId, planId, autoDebitStatus) => {
  const responseRedisData = await RedisInfo.redisDetails();

  const parentGroup = responseRedisData.ParentGroup;
  console.log("Parent Group in the updateAutoDebit:", parentGroup);
  const dealerMapCode = responseRedisData.DealerMapCode;
  console.log("Dealer Map Code in the updateAutoDebit:", dealerMapCode);
  const locCode = responseRedisData.LocCode;
  console.log("Location Code in the updateAutoDebit:", locCode);
  const token = sessionStorage.getItem("token");
  console.log("Token in the updateAutoDebit:", token);

  const API_URL = `${apiUrl}/api/v1/orderDetails/registerForAutoDebit`;

  const response = await axios.put(
    API_URL,
    {
      serviceId,
      planId,
      parentGroup,
      dealerMapCode,
      multiServiceDealerCode: responseRedisData.MultiServiceDealerCode,
      locationCode: locCode,
      autoDebit: !!autoDebitStatus
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

// generate order with auto debit
// generate order with auto debit
const generateOrder = async (
  selectedPlan,
  totalAmount,
  serviceId,
  serviceName,
  autoDebitStatus
) => {
  const responseRedisData = await RedisInfo.redisDetails();
  const parentGroup = responseRedisData.ParentGroup;
  const dealerMapCode = responseRedisData.DealerMapCode;
  const locCode = responseRedisData.LocCode;
  const token = sessionStorage.getItem("token");

  // CRITICAL FIX: Read dealer info from sessionStorage with localStorage fallback (for backward compatibility)
  // sessionStorage is preferred for sensitive data, but fallback ensures existing sessions work
  const dealerInfo = JSON.parse(
    sessionStorage.getItem("dealerInfo") ||
    localStorage.getItem("dealerInfo") ||
    "{}"
  );
  console.log("Retrieved dealer info:", dealerInfo);

  // Get Dealer GST State Code (prefer sessionStorage, fallback to localStorage)
  const dealerGstStateCode =
    sessionStorage.getItem("dealerGstStateCode") ||
    localStorage.getItem("dealerGstStateCode") ||
    dealerInfo.DealerGstStateCode;

  let cgstRate = "0",
    sgstRate = "0",
    igstRate = "0";

  if (dealerGstStateCode === "06") {
    cgstRate = "9";
    sgstRate = "9";
    igstRate = "0";
  } else {
    cgstRate = "0";
    sgstRate = "0";
    igstRate = "18";
  }

  // format to 2 decimal places
  const formatAmount = (value) => Number(value).toFixed(2);

  // ==============================
  //  COMMENTED LOGIC: Prevent order creation within 24 hours
  // ==============================

  // try {
  //   const recentTxnUrl = `${apiUrl}/api/v1/orderDetails/getRecentTransactions/${parentGroup}/${dealerMapCode}/${locCode}?lang=en`;
  //   const txnResponse = await axios.get(recentTxnUrl, {
  //     headers: { Authorization: `Bearer ${token}` },
  //   });

  //   if (txnResponse.data && txnResponse.data.length > 0) {
  //     const latestTxn = txnResponse.data[0]; // assuming API returns list sorted by latest first
  //     const orderDate = new Date(latestTxn.orderDate || latestTxn.createdDate);
  //     const now = new Date();

  //     const diffHours = Math.abs(now - orderDate) / (1000 * 60 * 60);

  //     if (diffHours < 24) {
  //       const remainingHours = Math.floor(24 - diffHours);
  //       const remainingMinutes = Math.floor((24 - diffHours) * 60) % 60;

  //       await Swal.fire({
  //         icon: "info",
  //         title: "Please wait before creating another order",
  //         text: `You can create a new order after ${remainingHours}h ${remainingMinutes}m.`,
  //         confirmButtonColor: "#3085d6",
  //       });

  //       return; // stop function before generating order
  //     }
  //   }
  // } catch (e) {
  //   console.error("Error checking recent transactions:", e);
  // }


  // ==============================
  // ✅ Proceed with normal order creation
  // ==============================

  // ✅ BASIC AMOUNT (GST BASE)
  const basicAmount = Number(selectedPlan?.planCost || 0);

  const API_URL = `${apiUrl}/api/v1/orderDetails/generateOrder`;

  const response = await axios.post(
    API_URL,
    {
      serviceName,
      planName: selectedPlan.planName,
      serviceId,
      planId: selectedPlan.planId,
      orderAmount: formatAmount(totalAmount),
      initialCallMinutes: selectedPlan.planCallMinutes,
      initialChats: selectedPlan.planTotalChats,
      initialPsfCalls: selectedPlan.planPsfCallMinutes ?? selectedPlan.PLAN_PSF_CALL_MINUTES ?? undefined,
      initialPsfChats: selectedPlan.planPsfMessages ?? selectedPlan.PLAN_PSF_MESSAGES ?? undefined,
      initialSmrCalls: selectedPlan.planSmrCallMinutes ?? selectedPlan.PLAN_SMR_CALL_MINUTES ?? undefined,
      initialSmrChats: selectedPlan.planSmrMessages ?? selectedPlan.PLAN_SMR_MESSAGES ?? undefined,
      initialPlanCost: formatAmount(selectedPlan.planCost),
      parentGroup,
      dealerMapCode,
      locationCode: locCode,
      autoDebit: !!autoDebitStatus,
      basicAmount: formatAmount(basicAmount),
      igstRate,
      cgstRate,
      sgstRate,
      igstAmount: formatAmount(
        (basicAmount * parseFloat(igstRate)) / 100
      ),
      cgstAmount: formatAmount(
        (basicAmount * parseFloat(cgstRate)) / 100
      ),
      sgstAmount: formatAmount(
        (basicAmount * parseFloat(sgstRate)) / 100
      ),
      forcode: responseRedisData.ForCode,
      outlet: responseRedisData.OutletCode,
      msilGstNumber:
        dealerInfo.MsilGstNumber || responseRedisData.MsilGstNumber,
      dealerPanNumber:
        dealerInfo.DealerPanNumber || responseRedisData.DealerPanNumber,
      dealerAddress:
        dealerInfo.DealerAddress || responseRedisData.DealerAddress,
      dealerState: dealerInfo.DealerState || responseRedisData.DealerState,
      ceoEmail: dealerInfo.CeoEmailId || responseRedisData.CeoEmailId,
      dealerGstNumber:
        dealerInfo.DealerGstNumber || responseRedisData.DealerGstNumber,
      dealerGstStateCode,
      dealerName: dealerInfo.DealerName || responseRedisData.DealerName,
      dealerPinCode: dealerInfo.DealerPinCode || responseRedisData.DealerPinCode,
      dealerPlaceOfSupply:
        dealerInfo.DealerPlaceOfSupply || responseRedisData.DealerPlaceOfSupply,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data;
};




const AutoDebitUpdate = { updateAutoDebit, generateOrder };
export default AutoDebitUpdate;
